import { useState, useCallback } from 'react'

import { t } from 'i18next'

import { KeywordListTotal } from '~/components/KeywordListTotal'
import Panel from '~/components/Panel'

import FormEditKeyword from './FormEditKeyword'

type Props = {
  campaignId: string
}

const CampaignAdditionalKeywordsTable = ({ campaignId }: Props) => {
  const [panelIsOpen, setPanelIstOpen] = useState(false)
  const [additionalTotal, setAdditionalTotal] = useState<number>(0)
  const [negativeTotal, setNegativeTotal] = useState<number>(0)
  const [sidePanelOpen, setSidePanelOpen] = useState<boolean>()

  const total = additionalTotal + negativeTotal

  return (
    <Panel
      isCollapsible
      initialCollapsibleState={false}
      onCollapse={setPanelIstOpen}
      unmountContentIfCollapse
      title={t('rm:keywords')}
      noPaddingBody
    >
      <div className="mx-3 my-2">
        <KeywordListTotal total={total} limit={100} />
      </div>
      <FormEditKeyword
        campaignId={campaignId}
        panelIsOpen={panelIsOpen}
        totalKeywords={total}
        sidePanelOpen={sidePanelOpen}
        setSidePanelOpen={(value: boolean) => {
          setSidePanelOpen(value)
        }}
        onTotalChange={value => {
          setAdditionalTotal(value)
        }}
      />
      <FormEditKeyword
        className="mt-5 mb-5"
        campaignId={campaignId}
        panelIsOpen={panelIsOpen}
        totalKeywords={total}
        sidePanelOpen={sidePanelOpen}
        setSidePanelOpen={(value: boolean) => {
          setSidePanelOpen(value)
        }}
        onTotalChange={value => {
          setNegativeTotal(value)
        }}
        isNegative
      />
    </Panel>
  )
}

export default CampaignAdditionalKeywordsTable
